<template>
  <div class="calculator-page">
    <div class="menu">
      <div
        class="client-type-section"
        :class="{
          'both-client-type': is_business_plus,
          'border-abo': app.calculator.clientType == 'ABO',
          'border-vip': app.calculator.clientType == 'VIP',
        }"
        @click="switchAboToVip"
      >
        <div
          v-if="!is_business_plus"
          class="client-type"
          :class="{
            VIP: app.calculator.clientType == 'VIP',
            ABO: app.calculator.clientType == 'ABO' && !toggler,
          }"
        >
          {{
            app.calculator.clientType == "ABO" && !toggler
              ? app.locale.lang_npa
              : app.locale.lang_vip
          }}
        </div>
        <div v-if="is_business_plus" style="display: flex">
          <div
            class="client-type"
            :data-title="'Зарабатывайте больше в статусе НПА'"
            :class="{
              VIP: app.calculator.clientType == 'VIP',
            }"
            style="cursor: pointer"
          >
            {{ app.locale.lang_vip }}
          </div>
          <div
            class="client-type client-type-sec"
            :data-title="app.locale.vipToAbo.replace('${differenceTotal}', differenceTotal)"
            :class="{
              ABO: app.calculator.clientType == 'ABO',
            }"
          >
            {{ app.locale.lang_npa }}
          </div>
        </div>
      </div>
      <div class="income">
        {{ app.locale.income_label }}:
        <button class="income__button" @click="openAwardsModal">
          <span class="income-cost">
            {{ formatCurrency(app.calculator.total) }}
          </span>
        </button>
      </div>

      <Popup ref="popup" class="settings-btn">
        <template v-slot:popup-button>
          <Button
            icon="settings"
            icon-color="#56565A"
            :icon-size="
              app.breakpoint.mobile ? ['16px', '16px'] : ['24px', '24px']
            "
            :icon-position="app.breakpoint.mobile ? 'center' : 'right'"
            :style="{ color: '#56565A' }"
            @click="
              app.tutorialStep == 'settings-open' &&
                changeTutorialStep('settings-popup-helper');
              tutorialHandler();
            "
          >
            <span class="title">
              {{ app.locale.buttons.settings }}
            </span>
          </Button>
        </template>
        <template v-slot:default>
          <SettingsPopup />
        </template>
      </Popup>

      <Popover
        v-if="app.tutorialStep == 'settings-open'"
        :class="this.app.tutorialStep"
        :title="this.app.locale.tutorial['settings-open-title']"
        :text="this.app.locale.tutorial['settings-open-text']"
        :isArrow="true"
        arrowPosition="top"
        arrowAlign="right"
      />
    </div>
    <Canvas ref="canvas" />
   
    <div v-if="showDuplicateButton" class="calculator-page__button-wrapper">
      <button class="calculator-page__duplicate-button" @click="duplicate">
        {{ app.locale.duplicate }} {{ duplicateCounter }}/{{ duplicateLimit }}
      </button>
    </div>
  </div>
</template>
<script>
import { Canvas } from "@components/Diagram";
import { Popup, Button, Popover } from "@components/UI";
import { useState } from "@src/App.store.js";
import { computed } from "vue";
// import { calcTree as CalcFantomTree } from "@src/utils/Calc.js";

import SettingsPopup from "@src/popups/Settings";

import "./calculator.scss";
import formatCurrency from "../utils/helpers/formatCurrency";

export default {
  name: "calcPage",
  components: {
    Canvas,
    Popup,
    Button,
    SettingsPopup,
    Popover,
  },
  provide() {
    return {
      incrementDuplicateCounter: this.incrementDuplicateCounter,
      duplicateCounter: computed(() => this.duplicateCounter),
      duplicateLimit: this.duplicateLimit,
      setShowDuplicateButton: this.setShowDuplicateButton,
    };
  },
  data() {
    return {
      duplicateCounter: 0,
      duplicateLimit: 5,
      showDuplicateButton: false,
      toggler: false,
    };
  },
  setup() {
    return useState();
  },
  methods: {
    formatCurrency,
    tutorialHandler() {
      if (this.app.tutorialStep)
        setTimeout(() => {
          this.changeTutorialStep("end");
          this.app.currentPopup.openSwitch();
        }, 1500);
    },
    duplicate() {
      this.$refs.canvas.$refs.tree.duplicate();
    },
    incrementDuplicateCounter() {
      this.duplicateCounter++;
    },
    openAwardsModal() {
      this.$refs.canvas.$refs.tree.$refs.branch.$refs.vertex.$refs.EditPopup.openSwitch();
    },
    setShowDuplicateButton(value) {
      this.showDuplicateButton = value;
    },
    // switchVipToAbo() {
    //   this.toggler = true;
    //   this.state.changeClientType("ABO");
    //   this.state.calcTree();
    // },
    switchAboToVip() {
      if (this.is_business_plus) {
        this.toggler = !this.toggler;
        const client_type =
          this.app.calculator.clientType == "VIP" ? "ABO" : "VIP";
        this.changeClientType(client_type);
        this.calcTree(this.tree, this.app.calculator.clientType, this.app.calculator);
      }
    },
  },
  computed: {
    is_business_plus() {
      return (
        // this.Tree.flag_bronze_start &&
        (this.Tree.level >= 9 &&
          this.Tree.businessNature == "VIP" &&
          this.Tree.personal_value + this.Tree.client_value >= 200 &&
          this.Tree.children.filter((c) => c.level >= 3).length >= 3) ||
        this.toggler
      );
    },
    calcAboTree() {
      let tree = { ...this.Tree },
        clientType = "ABO";
      let calculator = {
        clientType: "ABO",
        countryCode: this.app.country,
        country: this.app.country.code === "mn" ? 790.7693 : 730,
        date: null,
        total: 0,
      };
      let result = this.calcTree(tree, clientType, calculator);
      return {tree: result, calculator: calculator};
    },
    differenceTotal() {
      return `${formatCurrency(this.calcAboTree.calculator.total - this.app.calculator.total).replace(this.app.currency.symbol, "")} ${this.app.currency.symbol}`;
    },
  },
};
</script>
